import { createPaginator } from "@smithy/core";
import { ListCollectionsCommand, } from "../commands/ListCollectionsCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateListCollections = createPaginator(RekognitionClient, ListCollectionsCommand, "NextToken", "NextToken", "MaxResults");
